<form #form class="row" (submit)="onSubmit($event)">
  <slot #inputSlot id="input-slot" (slotchange)="onSlottedContentChanged()"></slot>
  <div class="form-group col-12 col-xs-12">
    <slot
      #actionsSlot
      gpeiSelectorBasedSlot
      [slot]="inputSlot"
      id="action-slot"
      name="form-group"
      [select]="actionSlotSelector"
      (slotchange)="onSlottedContentChanged()">
    </slot>
  </div>
</form>
